import React from "react";

import { Card, CardBody, CardHeader, Button } from "reactstrap";

import AccessLinkWarningAlert from "./AccessLinkWarningAlert";

const ProfileUpdateCard = (props) => {
  const { email, onNextStep } = props;

  return (
    <Card>
      <AccessLinkWarningAlert email={email} />
      <CardHeader>
        <span>Confirm your profile</span>
      </CardHeader>
      <CardBody>
        <p>
          To make sure that we calculate your nutrition requirements accurately,
          we need some information about yourself.
        </p>
        <br />
        <center>
          <Button size="lg" color="primary" onClick={onNextStep}>
            Get Started
          </Button>
        </center>
      </CardBody>
    </Card>
  );
};

export default ProfileUpdateCard;
